module.exports = __webpack_public_path__ + "img/notification-icon.a25d983a.svg";